document.addEventListener('DOMContentLoaded', () => {
  setHomeHeroHeaderHeight();
  initAllHomeHeroes();
});
window.addEventListener('load', () => {
  setHomeHeroHeaderHeight();
});
window.addEventListener('resize', debounceHomeHero(() => {
  setHomeHeroHeaderHeight();
}, 100));
document.addEventListener('shopify:section:load', (event) => {
  setHomeHeroHeaderHeight();
  const hero = event.target.querySelector('[data-home-hero]');
  if (hero) {
    initHomeHero(hero);
  }
});
function setHomeHeroHeaderHeight() {
  const header = document.querySelector('.custom-header.custom-header--fixed');
  if (!header) {
    document.documentElement.style.setProperty('--home-hero-header-height', '0px');
    return;
  }
  const headerHeight = header.getBoundingClientRect().height;
  document.documentElement.style.setProperty('--home-hero-header-height', `${headerHeight}px`);
}
function initAllHomeHeroes() {
  document.querySelectorAll('[data-home-hero]').forEach((hero) => {
    initHomeHero(hero);
  });
}
function initHomeHero(hero) {
  if (hero.dataset.heroInitialized === 'true') {
    return;
  }
  hero.dataset.heroInitialized = 'true';
  const mediaType = hero.dataset.mediaType;
  if (mediaType !== 'slider') {
    return;
  }
  const slides = Array.from(hero.querySelectorAll('[data-home-hero-slide]'));
  const dots = Array.from(hero.querySelectorAll('[data-home-hero-dot]'));
  const prevButton = hero.querySelector('[data-home-hero-prev]');
  const nextButton = hero.querySelector('[data-home-hero-next]');
  const autoplayEnabled = hero.dataset.autoplay === 'true';
  const autoplaySpeed = Number(hero.dataset.autoplaySpeed) || 5000;
  if (slides.length <= 1) {
    return;
  }
  let currentIndex = 0;
  let autoplayTimer = null;
  let touchStartX = 0;
  let touchEndX = 0;
  const showSlide = (index) => {
    if (index < 0) {
      index = slides.length - 1;
    }
    if (index >= slides.length) {
      index = 0;
    }
    currentIndex = index;
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === currentIndex);
    });
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === currentIndex);
    });
  };
  const nextSlide = () => {
    showSlide(currentIndex + 1);
  };
  const prevSlide = () => {
    showSlide(currentIndex - 1);
  };
  const stopAutoplay = () => {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  };
  const startAutoplay = () => {
    if (!autoplayEnabled) {
      return;
    }
    stopAutoplay();
    autoplayTimer = setInterval(() => {
      nextSlide();
    }, autoplaySpeed);
  };
  const restartAutoplay = () => {
    stopAutoplay();
    startAutoplay();
  };
  if (nextButton) {
    nextButton.addEventListener('click', () => {
      nextSlide();
      restartAutoplay();
    });
  }
  if (prevButton) {
    prevButton.addEventListener('click', () => {
      prevSlide();
      restartAutoplay();
    });
  }
  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = Number(dot.dataset.slideIndex);
      if (!Number.isNaN(index)) {
        showSlide(index);
        restartAutoplay();
      }
    });
  });
  hero.addEventListener('mouseenter', () => {
    stopAutoplay();
  });
  hero.addEventListener('mouseleave', () => {
    startAutoplay();
  });
  hero.addEventListener('touchstart', (event) => {
    touchStartX = event.changedTouches[0].screenX;
  }, { passive: true });
  hero.addEventListener('touchend', (event) => {
    touchEndX = event.changedTouches[0].screenX;
    const difference = touchStartX - touchEndX;
    if (Math.abs(difference) < 50) {
      return;
    }
    if (difference > 0) {
      nextSlide();
    } else {
      prevSlide();
    }
    restartAutoplay();
  }, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopAutoplay();
    } else {
      startAutoplay();
    }
  });
  showSlide(0);
  startAutoplay();
}
function debounceHomeHero(callback, delay) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(callback, delay);
  };
}